import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreContextValue } from 'src/lib/ComponentProps';

import ClockIconSvg from 'public/icons/clock.svg';

import { AllResourceUrls } from '../ContentOverviewToolbarFields';

import styles from './ReadTime.module.css';

type ReadTimeProps = {
	fields: {
		allResourceUrls: AllResourceUrls[];
		currentResourceUrl: string | undefined;
	};
};

export default function ReadTime(props: ReadTimeProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();

	let readTimeInSeconds = 0;
	if (sitecoreContext.route.templateId === sitecoreIds.Templates.ContentDetailsWildcardTemplateId) {
		readTimeInSeconds = props.fields?.allResourceUrls.reduce((s, { readTimeInSeconds }) => s + readTimeInSeconds, 0);
	} else {
		readTimeInSeconds =
			props.fields?.allResourceUrls.find((r) => r.url?.toLowerCase().trim() === props.fields?.currentResourceUrl?.toLowerCase().trim())
				?.readTimeInSeconds ?? 0;
	}

	let timeToDisplay = '';
	let timeToRead = 0;
	if (Math.ceil(readTimeInSeconds) >= 3600) {
		timeToRead = Math.ceil(readTimeInSeconds / 3600);
		timeToDisplay = `${timeToRead}-hour `;
	} else {
		timeToRead = Math.ceil(readTimeInSeconds / 60);
		timeToDisplay = `${timeToRead}-minute `;
	}

	return (
		<div className={`${styles.readTimeContainer}`} title={sitecoreContext.dictionary?.readTimeTooltip}>
			<ClockIconSvg className={styles.readTimeIcon} />

			<span className={styles.readTime} id="readTime">
				{readTimeInSeconds === 0 ? (
					<Text field={{ value: sitecoreContext.dictionary?.noReadTimeAvailable }} />
				) : (
					<>
						{timeToDisplay}
						<Text field={{ value: sitecoreContext.dictionary?.readTimeText }} />
					</>
				)}
			</span>
		</div>
	);
}
